



























































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Enums/Data
import { LogoSize, LogoType } from "@/data/enums/logos";
import { ContractStatusCodes } from "@/models/contracts";

// Types
import {
  IProvisionCategory,
  IProvisionConfiguration
} from "@/models/provisioning";

@Component({
  components: {
    "product-image": () =>
      import("@/components/app/global/products/productImage.vue"),
    "upmind-upgrade-message": () =>
      import("@/components/app/admin/upmind/upgradeMessage.vue")
  }
})
export default class ProvisionConfigurationListItem extends Vue {
  // Props

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: null })
  public configuration!: IProvisionConfiguration;

  @Prop({ default: null })
  public selectedConfigurations!: any;

  @Prop({ default: null })
  public categoryCode!: IProvisionCategory["code"] | null;

  @Prop({ default: true })
  public isMultiselect!: boolean;

  @Prop({ default: null })
  public disabledConfigurations!: IProvisionConfiguration["id"][];

  // Methods

  public itemSelected(value) {
    if (this.isDisabled) return;

    this.$emit("selectConfiguration", this.configuration, value);
  }

  public getTooltipProps(counters) {
    return {
      class: "provisioned-toolip",
      type: "is-dark",
      multilined: true,
      label: _.map(
        counters,
        counter =>
          `• ${counter.count} ${(this.getTooltipStatusLabel(
            counter.status_code
          ) as string)
            .toString()
            .toLowerCase()}`
      ).join("\n")
    };
  }

  public getTooltipStatusLabel(status) {
    switch (status) {
      case ContractStatusCodes.ACTIVE:
        return this.$t("_.active");
      case ContractStatusCodes.AWAITING_ACTIVATION:
        return this.$t("_.subscription_awaiting_activation_summary");
      case ContractStatusCodes.PENDING:
        return this.$t("_.subscription_pending_summary");
      case ContractStatusCodes.SUSPENDED:
        return this.$t("_.suspended");
      case ContractStatusCodes.CANCELLED:
        return this.$t("_.cancelled");
      case ContractStatusCodes.CLOSED:
        return this.$t("_.lapsed");
      default:
        return "";
    }
  }

  public goToContractProducts(configuration, isActive = true) {
    this.$router.push({
      name: isActive ? "admin__activeSubscriptions" : "adminSubscriptionsList",
      query: {
        CPL: `1;10;-created_at;provision_configuration_id|=|${configuration.id}`
      }
    });
  }

  // Computed

  public get showSkeletons() {
    return this.$_.isNull(this.configuration);
  }

  public get isSelectable() {
    return !_.isNil(this.selectedConfigurations);
  }

  public get providerLogo() {
    return {
      image: {
        full_url: _.get(
          _.find(
            _.get(this.configuration, "provider.logos", []),
            logo => logo.type === LogoType.ICON && logo.size === LogoSize.TWO_X
          ),
          "url",
          ""
        )
      },
      name: _.get(this.configuration, "provider.name", "")
    };
  }

  public get activeCount() {
    return _.get(
      _.find(_.get(this.configuration, "contract_product_counts", []), [
        "status_code",
        ContractStatusCodes.ACTIVE
      ]),
      "count",
      0
    );
  }

  public get totalCount() {
    return _.sum(
      _.map(
        _.get(this.configuration, "contract_product_counts", []),
        filteredCounter => {
          return filteredCounter.count;
        }
      )
    );
  }

  public get status() {
    return {
      type: this.configuration.enabled ? "is-success" : "is-grey",
      icon: this.configuration.enabled ? "check-circle" : "pause-circle",
      label: this.configuration.enabled
        ? this.$t("_.enabled")
        : this.$t("_.disabled")
    };
  }

  public get isSelected() {
    return (
      this.isSelectable &&
      _.some(this.selectedConfigurations, ["id", this.configuration?.id])
    );
  }

  public get isDisabled() {
    return (
      !_.isNil(this.disabledConfigurations) &&
      this.disabledConfigurations.includes(this.configuration?.id)
    );
  }
}
